const OSS = require('ali-oss')
import {
  getOssAuth
} from '../api/index'

// 文件扩展名提取
function fileType (fileName) {
  return fileName.substring(fileName.lastIndexOf('.') + 1)
}

// 文件上传
const ossUpload = function (file, name = '', listName = '', progress = ()=>{}) {
  return new Promise((resolve, reject) => {
    getOssAuth().then(res => {
      if (res.resultStatus) {
        const result = res.resultData
        const util = new OSS({
          endpoint: result.endpoint,
          accessKeyId: result.accessKeyId,
          accessKeySecret: result.accessKeySecret,
          stsToken: result.stsToken,
          bucket: result.bucketName
        })
        const type = fileType(file.name)
        // 拼接唯一文件名，防止重名覆盖
        const fileName = name || (Math.floor(Math.random() * 1000 * 150) + (+new Date()) + '.' + type)
        util.multipartUpload(listName + fileName, file, {
          partSize: 1000 * 256,
          timeout: 120000, // 超时2分钟
          progress
        }).then(res => {
          // 拼接完整访问地址
          let url = res.name[0] === '/' ? (result.bucketDomain + res.name) : (result.bucketDomain + '/' + res.name)
          if (url.indexOf('?') !== -1) {
            url = url.split('?')[0]
          }
          resolve({
            url,
            type: file.name ? fileType(file.name) : 'html'
          })
        }).catch(err => {
          console.error('OSS上传失败：', err)
          reject({ url: '' })
        })
      } else {
        reject({ url: '' })
      }
    })
  })
}

export { ossUpload }
